const initialState = [];

export default (state = initialState, action) => {
    switch (action.type) {
        case "CERTIFICATE_TYPES_RETRIEVED":
            return action.certificateTypes;

        default:
            return state;
    }
}
